/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TeamMember } from '@marageti/z4-sdk/lib/people';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { useApiClient } from '@marageti/z4-lib';
import { RoleName } from '@marageti/z4-sdk/lib/auth';
import UsersView from './users-view';
import { getMatchingUser } from '../../../utils/auth';
import { compareNames } from '../../../utils/helpers';
import { useAuthStore } from '../../../store';

const UsersContainer = () => {
  const { loggedInTeamMember } = useAuthStore();
  const isAdmin = loggedInTeamMember?.userInfo?.[0].roles?.includes(RoleName.ADMIN);
  const [showDisabled, setShowDisabled] = useState(false);
  const [teamMembers, setTeamMembers] = useState<Array<TeamMember>>([]);
  const [inviteOpen, setInviteOpen] = useState(false);
  const [apiError, setApiError] = useState<ApiError>();

  const navigate = useNavigate();
  const apiClient = useApiClient();

  const getAllTeamMembers = () => {
    apiClient.peopleClient
      .getTeamMembers({ params: { limit: 1000 } })
      .then((teamMemberList: Array<TeamMember>) => {
        if (teamMemberList) {
          teamMemberList.sort(compareNames);
          setTeamMembers(teamMemberList);
        }
      })
      .catch((error: ApiError) => {
        if (error.code === 401) navigate('/logout');
        setApiError(error);
      });
  };

  useEffect(() => {
    getAllTeamMembers();
  }, []);

  const handleCloseInvite = () => {
    getAllTeamMembers();
    setInviteOpen(false);
  };

  const handleOpenInvite = () => {
    setInviteOpen(true);
  };

  const filteredList = teamMembers.filter((tM) => getMatchingUser(tM.email, tM.userInfo)?.status !== 'DISABLED');
  const toggleShowDisabled = (e: React.ChangeEvent<HTMLInputElement>) => { setShowDisabled(e.target.checked); };

  return (
    <UsersView
      error={apiError}
      inviteOpen={inviteOpen}
      isAdmin={!!isAdmin}
      onCloseInvite={handleCloseInvite}
      onOpenInvite={handleOpenInvite}
      showDisabled={showDisabled}
      teamMembers={showDisabled ? teamMembers : filteredList}
      toggleShowDisabled={toggleShowDisabled}
    />
  );
};

export default UsersContainer;
